export const iconFontAwesomeHouseholdHouseLock = (
	<i className="fa-solid fa-house-lock"></i>
);
